<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content" v-if="'I' === dispType">
                    <dt class="ellipsis">
                        <i>China {{ $t('FIELD.GLOBAL.INQUIRY.TYPE') }} {{ $t('FIELD.SURVEY.SUMMARY.LANG') }}</i>
                    </dt>
                    <dd>
                        <!-- Grid -->
                        <div class="grid_wrap only_grid">
                            <table class="grid_table">
                                <colgroup>
                                    <col width="25%" />
                                    <col width="25%" />
                                    <col width="25%" />
                                    <col width="25%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{ $t('FIELD.GLOBAL.INQUIRY1') }}</th>
                                        <th>{{ $t('FIELD.CHINA.INQUIRY1') }}</th>
                                        <th>{{ $t('FIELD.GLOBAL.INQUIRY2') }}</th>
                                        <th>{{ $t('FIELD.CHINA.INQUIRY2') }}</th>
                                    </tr>
                                </thead>
                                <tbody class="text_center">
                                    <tr v-for="item in inquiryList" :key="pageName + item.EN_INQ1 + item.EN_INQ2">
                                        <td>{{ item.EN_INQ1 }}</td>
                                        <td>{{ item.CN_INQ1 }}</td>
                                        <td>{{ item.EN_INQ2 }}</td>
                                        <td>{{ item.CN_INQ2 }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </dd>
                </dl>
                <dl class="modal_content" v-if="'C' === dispType">
                    <dt class="ellipsis">
                        <i>China {{ $t('FIELD.GLOBAL.INQUIRY.TYPE') }} {{ $t('FIELD.SURVEY.SUMMARY.LANG') }}</i>
                    </dt>
                    <dd>
                        <!-- Grid -->
                        <div class="grid_wrap only_grid">
                            <table class="grid_table">
                                <colgroup>
                                    <col width="15%" />
                                    <col width="15%" />
                                    <col width="15%" />
                                    <col width="15%" />
                                    <col width="15%" />
                                    <col width="*" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{ $t('FIELD.GLOBAL.CATEGORY1') }}</th>
                                        <th>{{ $t('FIELD.CHINA.CATEGORY1') }}</th>
                                        <th>{{ $t('FIELD.GLOBAL.CATEGORY2') }}</th>
                                        <th>{{ $t('FIELD.CHINA.CATEGORY2') }}</th>
                                        <th>{{ $t('FIELD.GLOBAL.CATEGORY3') }}</th>
                                        <th>{{ $t('FIELD.CHINA.CATEGORY3') }}</th>
                                    </tr>
                                </thead>
                                <tbody class="text_center">
                                    <tr
                                        v-for="item in categoryList"
                                        :key="pageName + item.EN_CAT1 + item.EN_CAT2 + item.EN_CAT3"
                                    >
                                        <td>{{ item.EN_CAT1 }}</td>
                                        <td>{{ item.CN_CAT1 }}</td>
                                        <td>{{ item.EN_CAT2 }}</td>
                                        <td>{{ item.CN_CAT2 }}</td>
                                        <td>{{ item.EN_CAT3 }}</td>
                                        <td>{{ item.CN_CAT3 }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import { mapGetters } from 'vuex';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';

export default {
    name: 'searchZHPopup',
    props: {
        dispType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            pageName: 'searchZHPopup',
            inquiryList: [],
            categoryList: [],
        };
    },
    mounted() {
        this.onSearch();
    },
    computed: {
        ...mapGetters({
            userCorpCd: 'getCorpCd',
        }),
        getUserCorpCd() {
            let userInfo = SDLUtil.getLoginedUserInfo() || { companyCode: '' };
            // return this.userCorpCd || '';
            return 'C610';
        },
    },
    methods: {
        async onSearch() {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/dispCNLangPop.skp`,
                    qs.stringify({ dispType: this.dispType, corpNo: this.getUserCorpCd }),
                )
                .then(resp => {
                    if ('I' === this.dispType) {
                        this.inquiryList = resp.data.result.rowData;
                    } else if ('C' === this.dispType) {
                        this.categoryList = resp.data.result.rowData;
                    }
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/searchZHPopup.vue